<template>
  <div>
    <primary-title>佣金查詢</primary-title>
    <base-box title="查詢條件">
      <v-container grid-list-md>
        <v-layout row
                  wrap
                  class="form">
          <v-flex sm6>
            <sub-header class="required"><template v-slot:title>佣金月份</template></sub-header>
            <v-layout row
                      wrap
                      class="form">
            <div class="d-flex">
            <v-flex xs6>
            <v-select v-model="startMonth"
                      :items="startMonthList"
                      item-text="codeValue"
                      item-value="codeValue"
                      outline></v-select>

            </v-flex>
            <span style="margin-top: 10px">~</span>
            <v-flex xs6>
            <v-select v-model="endMonth"
                      :items="endMonthList"
                      item-text="codeValue"
                      item-value="codeValue"
                      outline></v-select>
            </v-flex>
            </div>
            </v-layout>
          </v-flex>
        </v-layout>
        <base-note no-num
                  style="margin-bottom:0px">業務員外部入口網僅提供一年內獎金資訊,若欲查詢更久資訊請至內網保經業管系統\業務專區查詢。</base-note>
      </v-container>
    </base-box>
    <base-btn>
      <btn-lg-secondary @click.native="queryHandler">查詢</btn-lg-secondary>
    </base-btn>
    <base-container has-title
                    title="查詢結果"
                    v-if="showSearchResult">
      <v-data-table :headers="headers"
                    :items="ssDetailList"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5,10,15,25,50]"
                    rows-per-page-text="顯示資料筆數"
                    no-data-text="此月份沒有資料可顯示"
                    class="elevation-1">
        <template v-slot:headers="props">
          <th v-for="header in props.headers"
              :key="header.value"
              :width="header.width"
              :class="['column', pagination.descending ? 'desc' : 'asc', 'sortable active']">
            <span v-html="header.text"></span>
          </th>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.period }}</td>
            <td>{{ props.item.bTypeName }}</td>
            <td class="text-xs-center">{{ props.item.sNo }}</td>
            <td class="text-xs-center">{{ props.item.iNo }}</td>
            <td class="text-xs-center">{{ props.item.payerNameMask }}</td>
            <td class="text-xs-center">{{ props.item.insNameMask }}</td>
            <td class="text-xs-center">{{ props.item.aliasName }}</td>
            <td class="text-xs-center">{{ props.item.prodName }}</td>
            <td class="text-xs-center">{{ props.item.srcItemName }}</td>
            <td class="text-xs-center">{{ props.item.itemName }}</td>
            <td class="text-xs-center">{{ props.item.benefit | $commaFormat }}</td>
            <td class="text-xs-center">{{ props.item.fyp | $commaFormat }}</td>
            <td class="text-xs-center">{{ props.item.bKindName }}</td>
            <td class="text-xs-center">{{ props.item.fyc | $commaFormat }}</td>
            <td class="text-xs-center">
              <v-btn outline
                     fab
                     small
                     v-ripple="false"
                     @click="previewHandler(props.item)">檢視</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-container>
    <!-- 預覽 -->
    <base-dialog-adm v-if="previewDialogShow"
                 :show="previewDialogShow"
                 title="佣獎明細"
                 width="60%"
                 :btn-confirm=false
                 btn-close-text="關閉"
                 @close="previewDialogCloseHandler">
      <commission-preview :preview-item="previewItem"></commission-preview>
    </base-dialog-adm>
  </div>
</template>
<script>
import CommissionPreview from './CommissionPreview'
export default {
  name: 'commission-search',
  props: {},
  components: { CommissionPreview },
  data () {
    return {
      startMonth: new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString().substr(0, 7).replace('-', ''),
      endMonth: new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString().substr(0, 7).replace('-', ''),
      ssDetailList: [],
      headers: [
        { text: '業績<br/>月份', align: 'center', value: 'period', width: '5%' },
        { text: '佣金<br/>類別', align: 'center', value: 'bTypeName', width: '4%' },
        { text: '受理<br/>編號', align: 'center', value: 'sNo', width: '8%' },
        { text: '保單<br/>編號', align: 'center', value: 'iNo', width: '8%' },
        { text: '要保人<br/>姓名', align: 'center', value: 'payerName', width: '9%' },
        { text: '被保人<br/>姓名', align: 'center', value: 'insName', width: '9%' },
        { text: '保險<br/>公司', align: 'center', value: 'aliasName', width: '6%' },
        { text: '險種<br/>名稱', align: 'center', value: 'prodName', width: '10%' },
        { text: '獎金<br/>名稱', align: 'center', value: 'srcItemName', width: '5%' },
        { text: '繳別', align: 'center', value: 'itemName', width: '4%' },
        { text: '保額', align: 'center', value: 'benefit', width: '5%' },
        { text: '保費', align: 'center', value: 'fyp', width: '8%' },
        { text: '佣金<br/>性質', align: 'center', value: 'bKindName', width: '6%' },
        { text: '營業員<br/>奬金', align: 'center', value: 'fyc', width: '7%' },
        { text: '明細', align: 'center', value: '', width: '6%' }
      ],
      pagination: {
        sortBy: 'period',
        descending: true,
        rowsPerPage: 15
      },
      previewItem: {},
      previewDialogShow: false,
      showSearchResult: false
    }
  },
  watch: {

  },
  methods: {
    queryHandler () {
      if (this.startMonth > this.endMonth) {
        this.$alert('佣金月份-起 不可大於 佣金月份-迄!')
        return
      }
      this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'commissionSearch_query', methodName: '查詢' }))
      this.$nextTick(() => {
        this.ssDetailList = []
      })
      const vm = this
      const params = { startMonth: vm.startMonth, endMonth: vm.endMonth }
      this.showSearchResult = false
      this.$api.get('/commission/SSDetailList', { params }).then(r => {
        vm.ssDetailList = r.data || []
        vm.showSearchResult = true
      })
    },
    previewHandler ({ period, empID, recNo }) {
      const params = { period: period, empID: empID, recNo: recNo }
      this.$api.get('/commission/SSDetailList', { params }).then(r => {
        this.previewItem = (r.data.length > 0 && r.data[0]) || {}
        this.previewDialogToggle()
      })
    },
    previewDialogToggle () {
      this.previewDialogShow = !this.previewDialogShow
    },
    previewDialogCloseHandler () {
      this.previewDialogToggle()
      this.previewItem = {}
    },
    headerHandler (column) {
      // if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
        this.pagination.sortBy = column
      // }
    }
  },
  computed: {
    startMonthList () {
      let startlist = []
      let startDate = new Date()
      startDate.setMonth(startDate.getMonth() - 1)
      for (var i=0; i<12; i++) {
        const startmonth = startDate.getMonth()
        let item = { codeValue: ''}
        item.codeValue = new Date(startDate.setMonth(startDate.getMonth() - 1 )).toISOString().substr(0, 7).replace('-', '')
        if (startmonth === startDate.getMonth()) {
          item.codeValue = new Date(startDate.setMonth(startDate.getMonth() - 1 )).toISOString().substr(0, 7).replace('-', '')
        }
        startlist.push(item)
      }
      return startlist
    },
    endMonthList () {
      let endlist = []
      let endDate = new Date()
      endDate.setMonth(endDate.getMonth() - 1 )
      for (var j=0; j<12; j++) {
        const endmonth = endDate.getMonth()
        let item = { codeValue: ''}
        item.codeValue = new Date(endDate.setMonth(endDate.getMonth() - 1 )).toISOString().substr(0, 7).replace('-', '')
        if (endmonth === endDate.getMonth()) {
          item.codeValue = new Date(endDate.setMonth(endDate.getMonth() - 1 )).toISOString().substr(0, 7).replace('-', '')
        }
        endlist.push(item)
      }
      return endlist
    }
  },
  created () {}
}
</script>
